const resource = {
    resource_identifier_in_use: 'O identificador de API {{indicator}} já está em uso',
};
export default Object.freeze(resource);
